import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

const CategorySelectionComponent = ({
  detail,
  index,
  categories,
  handleChange,
  handleDelete,
}) => {
  // Extract category data
  const categoryData = categories.find(
    (cat) => cat.CategorieName === detail.type
  );

  // Parse CategorieFields
  const parsedFields = categoryData
    ? JSON.parse(categoryData.CategorieFields || "[]")
    : [];

  // Get options based on category type
  const cateringOptions =
    detail.type === "VENUE"
      ? parsedFields.find((field) => field.fieldName === "Catering")?.options
      : null;

  const budgetSlabOptions = ["VENUE", "WEDDING CATERERS"].includes(detail.type)
    ? parsedFields.find((field) => field.fieldName === "BudgetSlab")?.options
    : null;

  const vegNonVegOptions =
    detail.type === "WEDDING CATERERS"
      ? parsedFields.find((field) => field.fieldName === "Veg")?.options
      : null;

  const totalBudgetOptions = ![
    "VENUE",
    "WEDDING CATERERS",
    "WEDDING ENTERTAINMENT",
  ].includes(detail.type)
    ? parsedFields.find((field) => field.fieldName === "TotalBudget")
        ?.options || [
        "<10000",
        "10000-20000",
        "20000-30000",
        "30000-40000",
        "40000-50000",
        "50000+",
      ]
    : null;

  const eventCategoryOptions =
    detail.type === "WEDDING ENTERTAINMENT"
      ? parsedFields.find((field) => field.fieldName === "EVENTS CATEGORY")
          ?.options
      : null;

  const artistCategoryOptions =
    detail.type === "WEDDING ENTERTAINMENT"
      ? parsedFields.find((field) => field.fieldName === "ARTIST CATEGORY")
          ?.options
      : null;

  const selectedBudgetField = detail.artistCategory
    ? `${detail.artistCategory.toUpperCase().replace(/\s+/g, "")}TotalBudget`
    : null;

  const artistTotalBudgetOptions =
    detail.type === "WEDDING ENTERTAINMENT" && selectedBudgetField
      ? parsedFields.find((field) => field.fieldName === selectedBudgetField)
          ?.options
      : null;

  return (
    <Row key={index} className="mb-3 align-items-center">
      {/* Custom Category Input */}
      <Col style={{ minWidth: "100px" }}>
        <Form.Control
          style={{ fontSize: "130%", fontWeight: "bold" }}
          type="text"
          placeholder="Type Custom Category"
          value={detail.type}
          onChange={(e) => handleChange(e, index, "type")}
        />
      </Col>

      {/* Venue: Catering Selection */}
      {cateringOptions && (
        <Col style={{ minWidth: "100px" }}>
          <select
            className="form-control"
            value={detail.catering || ""}
            onChange={(e) => handleChange(e, index, "catering")}
          >
            <option value="">Select Catering</option>
            {cateringOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Venue: Budget Slab Selection */}
      {detail.type === "VENUE" && detail.catering && budgetSlabOptions && (
        <Col style={{ minWidth: "100px" }}>
          <select
            className="form-control"
            value={detail.price || ""}
            onChange={(e) => handleChange(e, index, "price")}
          >
            <option value="">Select Budget Slab</option>
            {budgetSlabOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Wedding Caterers: Veg/Non-Veg Selection */}
      {vegNonVegOptions && (
        <Col style={{ minWidth: "80px" }}>
          <select
            className="form-control"
            value={detail.vegNonVeg || ""}
            onChange={(e) => handleChange(e, index, "vegNonVeg")}
          >
            <option value="">Select Veg</option>
            {vegNonVegOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Wedding Caterers: Budget Slab Selection */}
      {detail.type === "WEDDING CATERERS" &&
        detail.vegNonVeg &&
        budgetSlabOptions && (
          <Col style={{ minWidth: "90px" }}>
            <select
              className="form-control"
              value={detail.price || ""}
              onChange={(e) => handleChange(e, index, "price")}
            >
              <option value="">Select Budget Slab</option>
              {budgetSlabOptions.map((option, i) => (
                <option key={i} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </Col>
        )}

      {/* Wedding Entertainment: Event Category */}
      {eventCategoryOptions && (
        <Col
          style={{
            minWidth: "150px", // Set the minimum width for the column
            maxWidth: "200px", // Set the max width for the column to prevent it from increasing
            zIndex: "100",
            bottom: "4px",
            position: "relative",
            display: "flex",
            overflow: "hidden", // Prevent any content from overflowing
          }}
        >
          <Select
            isMulti
            isSearchable={false}
            options={eventCategoryOptions.map((option) => ({
              value: option,
              label: option,
            }))}
            value={
              eventCategoryOptions
                .map((option) => ({ value: option, label: option }))
                .filter(
                  (opt) =>
                    detail.eventCategory &&
                    detail.eventCategory.includes(opt.value)
                ) || []
            }
            onChange={(selectedOption) => {
              // Log selected options
              console.log("Selected event categories:", selectedOption);

              // Handle change (pass the selected options as an array of values)
              handleChange(
                {
                  target: {
                    value: selectedOption
                      ? selectedOption.map((opt) => opt.value)
                      : [], // Array of selected values
                  },
                },
                index,
                "eventCategory"
              );
            }}
            placeholder="Select Event Categories"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                height: "35px", // Decrease the height of the control
                minHeight: "35px",
                display: "flex",
                flexWrap: "wrap", // Allow wrapping of items if necessary
                overflow: "hidden", // Hide overflowing content
                position: "relative", // Allow the dropdown to appear outside the container
                width: "100%", // Ensure the Select input doesn't grow beyond the column's width
                padding: "0 35px 0 8px", // Add space for the dropdown indicator and clear button
              }),
              multiValue: (provided) => ({
                ...provided,
                fontSize: "11px", // Adjust the font size inside selected items
                margin: "2px", // Margin to ensure items have space between them
                whiteSpace: "nowrap", // Prevent text from breaking into multiple lines
                display: "inline-flex", // Keep items in a row
                flexShrink: "0", // Prevent items from shrinking and overflowing
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: "0 8px", // Adjust padding of the dropdown indicator
                position: "absolute", // Position the indicator absolutely
                right: "20px", // Align it to the right
                top: "50%", // Vertically center the indicator
                transform: "translateY(-50%)", // Ensure it’s perfectly centered vertically
              }),
              indicatorSeparator: (provided) => ({
                ...provided,
                padding: "0 8px", // Adjust padding of the dropdown indicator
                position: "absolute", // Position the indicator absolutely
                right: "5px", // Align it to the right
                top: "50%", // Vertically center the indicator
                transform: "translateY(-50%)", // Ensure it’s perfectly centered vertically
              }),
              clearIndicator: (provided) => ({
                ...provided,
                padding: "0 8px", // Adjust padding of the clear indicator
                position: "absolute", // Position the clear icon absolutely
                right: "2px", // Align it to the far right of the input
                top: "50%", // Vertically center the icon
                transform: "translateY(-50%)", // Ensure it’s perfectly centered vertically
              }),
              option: (provided) => ({
                ...provided,
                fontSize: "11px", // Adjust font size inside options
              }),
              menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999, // Ensure the dropdown appears above other elements
              }),
            }}
            menuPortalTarget={document.body} // This ensures the dropdown menu is rendered outside the container
          />
        </Col>
      )}

      {/* Wedding Entertainment: Artist Category */}
      {detail.eventCategory && artistCategoryOptions && (
        <Col style={{ minWidth: "100px" }}>
          <select
            className="form-control"
            value={detail.artistCategory || ""}
            onChange={(e) => handleChange(e, index, "artistCategory")}
          >
            <option value="">Select Artist Category</option>
            {artistCategoryOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Wedding Entertainment: Total Budget */}
      {detail.artistCategory && artistTotalBudgetOptions && (
        <Col style={{ minWidth: "100px" }}>
          <select
            className="form-control"
            value={detail.price || ""}
            onChange={(e) => handleChange(e, index, "price")}
          >
            <option value="">Select Total Budget</option>
            {artistTotalBudgetOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Other Categories: Directly Show Total Budget */}
      {totalBudgetOptions && (
        <Col style={{ minWidth: "100px" }}>
          <select
            className="form-control"
            value={detail.price || ""}
            onChange={(e) => handleChange(e, index, "price")}
          >
            <option value="">Select Total Budget</option>
            {totalBudgetOptions.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </Col>
      )}

      {/* Delete Button */}
      <Col xs="auto">
        <Button
          variant="danger"
          style={{ background: "none", border: "none", color: "red" }}
          onClick={() => handleDelete(index)}
        >
          ❌
        </Button>
      </Col>
    </Row>
  );
};

export default CategorySelectionComponent;
